module.exports = __webpack_public_path__ + "img/icon_map_10_off_111.5787cb77.png";